/** El reporte semanal de gastos tal como lo da `GET /publico/gastos/{token}`. Montos en USD. */

export type PagoGasto = {
  fecha: string
  codigo: string
  proveedor: string
  concepto: string
  monto: string
}

export type CategoriaDelMes = {
  categoria: string
  tipo: string | null
  total: string
  ordenes: number
}

export type PartidaGastos = {
  categoria: string
  tope: string
  ejecutado: string
  comprometido: string
  disponible: string
  porcentaje: number
  alerta: string | null
}

export type Gastos = {
  empresa_nombre: string
  empresa_rif: string
  titulo: string
  generado_en: string
  expira_en: string
  semana: {
    desde: string
    hasta: string
    total: string
    pagos: PagoGasto[]
    sin_convertir: string[]
  }
  mes: {
    anio: number
    mes: number
    hasta: string
    ejecutado: string
    ordenes: number
    fijos: string
    variables: string
    sin_clasificar: string
    pendiente: string
    ordenes_pendientes: number
    por_categoria: CategoriaDelMes[]
    sin_convertir: string[]
  }
  presupuesto: {
    tope: string
    usado: string
    ejecutado: string
    comprometido: string
    disponible: string
    fuera_de_partida: string
    comprometido_fuera: string
    partidas: PartidaGastos[]
  }
}

export const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
]

/** «Octubre 2026». */
export function nombreDelMes(anio: number, mes: number): string {
  const nombre = MESES[mes - 1] ?? String(mes)
  return `${nombre.charAt(0).toUpperCase()}${nombre.slice(1)} ${anio}`
}
